export const Notesicon = ({ primaryFontColor = '#ffd800' }) => {
  return (
    <svg
      id="_006-notes"
      data-name="006-notes"
      xmlns="http://www.w3.org/2000/svg"
      width="21.997"
      height="22"
      viewBox="0 0 21.997 22"
    >
      <g
        id="Group_2257"
        data-name="Group 2257"
        transform="translate(18.609 7.87)"
      >
        <g id="Group_2256" data-name="Group 2256">
          <path
            id="Path_6297"
            data-name="Path 6297"
            d="M425.8,179.5a1.715,1.715,0,0,0-2.413.209l-.371.438,2.626,2.2.354-.437A1.71,1.71,0,0,0,425.8,179.5Z"
            transform="translate(-423.012 -179.099)"
            fill={primaryFontColor}
          />
        </g>
      </g>
      <g
        id="Group_2259"
        data-name="Group 2259"
        transform="translate(12.026 15.85)"
      >
        <g id="Group_2258" data-name="Group 2258">
          <path
            id="Path_6298"
            data-name="Path 6298"
            d="M273.713,350.534l-.2.231a1.728,1.728,0,0,0-.353.7l-.531,2.223a.572.572,0,0,0,.783.657l2.1-.909a1.728,1.728,0,0,0,.63-.469l.2-.232Z"
            transform="translate(-272.617 -350.534)"
            fill={primaryFontColor}
          />
        </g>
      </g>
      <g
        id="Group_2261"
        data-name="Group 2261"
        transform="translate(14.713 10.353)"
      >
        <g id="Group_2260" data-name="Group 2260">
          <path
            id="Path_6299"
            data-name="Path 6299"
            d="M323.892,229.517l-3.159,3.737,2.626,2.2,3.158-3.737Z"
            transform="translate(-320.733 -229.517)"
            fill={primaryFontColor}
          />
        </g>
      </g>
      <g
        id="Group_2263"
        data-name="Group 2263"
        transform="translate(13.199 0.087)"
      >
        <g id="Group_2262" data-name="Group 2262">
          <path
            id="Path_6300"
            data-name="Path 6300"
            d="M302.933,4.74l-2.17-2.062a1.686,1.686,0,0,0-.724-.384V5.635h3.392A1.721,1.721,0,0,0,302.933,4.74Z"
            transform="translate(-300.039 -2.294)"
            fill={primaryFontColor}
          />
        </g>
      </g>
      <g id="Group_2265" data-name="Group 2265">
        <g id="Group_2264" data-name="Group 2264">
          <path
            id="Path_6301"
            data-name="Path 6301"
            d="M11.507,15.816a3.208,3.208,0,0,1,.687-1.32l5.2-5.939v-3.4H12.719a.656.656,0,0,1-.667-.645V0H2.04a1.971,1.971,0,0,0-2,1.934V20.066A1.971,1.971,0,0,0,2.04,22H15.388a1.971,1.971,0,0,0,2-1.934V18.543l-.087.1a3.344,3.344,0,0,1-1.222.879L13.63,20.548a2.052,2.052,0,0,1-2.083-.293,1.886,1.886,0,0,1-.661-1.931ZM3.375,3.867h6.674a.645.645,0,1,1,0,1.289H3.375a.645.645,0,1,1,0-1.289Zm0,3.91H14.054a.645.645,0,1,1,0,1.289H3.375a.645.645,0,1,1,0-1.289ZM8.714,16.8H3.375a.645.645,0,1,1,0-1.289H8.714a.645.645,0,1,1,0,1.289ZM3.375,12.934a.645.645,0,1,1,0-1.289h8.009a.645.645,0,1,1,0,1.289Z"
            transform="translate(-0.038)"
            fill={primaryFontColor}
          />
        </g>
      </g>
    </svg>
  );
};
